var map = {
	"./appIcon-menu--AccountDashboard--active.svg": "608b",
	"./appIcon-menu--Applications--active.svg": "e336",
	"./appIcon-menu--Components--active.svg": "fdfd",
	"./appIcon-menu--Contacts--active.svg": "fc48",
	"./appIcon-menu--Integrations--active.svg": "eeb6",
	"./appIcon-menu--Invoicing--active.svg": "f21e",
	"./appIcon-menu--Reports--active.svg": "117d",
	"./appIcon-menu--Revenue--active.svg": "1958",
	"./appIcon-menu--Settings--active.svg": "f802",
	"./appIcon-menu--Subscriptions--active.svg": "92fc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5d22";